import { Injectable, InjectionToken, Optional, Inject, NgZone } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { withLatestFrom, flatMap, map, catchError, tap } from 'rxjs/operators';

import { enterZone } from '../shared/utils/rxjs/operators';

import { initializeWallet, transaction, confirmOperation, originateContract, getWallet, Config } from 'tezos-wallet'

@Injectable()
export class TransactionsEffects {

    // get transactions data from users big map
    @Effect()
    TransactionsLoadWallet$ = this.actions$.pipe(
        ofType('TRANSACTIONS_LOAD'),

        // get state from store
        withLatestFrom(this.store, (action, state: any) => ({ action, state })),

        flatMap(({ action, state }) =>
            // this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/629/contents/?depth=5')
            this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/654/contents/?depth=5')
        ),

        map((response) => ({ type: 'TRANSACTIONS_LOAD_SUCCESS', payload: response })),
        catchError((error, caught) => {
            console.error(error.message)
            this.store.dispatch({
                type: 'TRANSACTIONS_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }),
    );


    constructor(
        private actions$: Actions,
        private store: Store<any>,
        private router: Router,
        private http: HttpClient,
        private zone: NgZone,
    ) { }

}